<template>
    <confirmation-modal titleKey="admin.company.mergeTitle" :confirm="confirm" :valid="valid" :message="message">
      <wo-region>
        <po-input-field v-model="searchText" v-focus="true" name="searchText" label-key="user.company" placeholder-key='general.searchTextPlaceholder' :debounce="true" />
        <div class="wo-scroll-pane" v-if="companies">
          <po-table v-if="hasCompanies">
            <po-table-header slot="header" :columns="columns" />
            <template slot="body">
              <tr v-for="company in companies.items" :key="company.id">
                <td><wo-radio :id="company.id + ''" name="company" @input="selectCompany(company)">{{ company.name }}</wo-radio></td>
                <td><span v-if="company.account_number">&nbsp;<span v-t="'company.customer'" />{{ company.account_number }}</span></td>
              </tr>
            </template>
          </po-table>
          <po-empty-state v-else />
        </div>
      </wo-region>
    </confirmation-modal>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import filtered from '@/mixins/filtered'

import { Company } from '@/model/company'
import { companyRepository } from '@/repository/company'

import ConfirmationModal from '@/components/modal/ConfirmationModal'

export default {
  mixins: [filtered],
  components: { ConfirmationModal },
  props: {
    company: Company
  },
  data () {
    return {
      searchText: undefined,
      companies: undefined,
      selectedCompany: undefined
    }
  },
  computed: mapState({
    valid () {
      return !!this.selectedCompany && this.selectedCompany.id !== this.company.id
    },
    message () {
      return this.$t('admin.company.mergeMessage', this.company)
    },
    hasCompanies () {
      return this.companies && !_.isEmpty(this.companies.items)
    },
    filter () {
      return { search_text: this.searchText }
    },
    columns () {
      return [
        { labelKey: 'company.name' },
        { labelKey: 'company.customer' }
      ]
    }
  }),
  methods: {
    confirm () {
      if (this.selectedCompany) {
        const action = {
          action: 'merge',
          company_id: this.selectedCompany.id
        }
        return this.$store.dispatch(companyRepository.execute, { entity: this.company, action: action })
      }
    },
    applyFilter (filter, pristine) {
      if (this.searchText) {
        this.selectCompany()
        return this.$store.dispatch(companyRepository.findAll, { filter: filter, replace: !pristine })
          .then(result => { this.companies = result })
      }
    },
    selectCompany (company) {
      this.selectedCompany = company
    }
  }
}
</script>
<style lang="scss">
  .wo-scroll-pane {
    overflow-y: auto;
    height: 30vh;
    max-height: 30vh;
  }

  .po-table .wo-radio {
    margin-left: 5px;
  }
</style>
